export const Data = [
  {
    id: "1",
    name: "mark",
    email: "aaaaaa@mail.com",
    age: 20,
    phone: "0101858401",
    access: "Admin"
  },
  {
    id: "2",
    name: "Elonmask",
    email: "x@mail.com",
    age: 20,
    phone: "0101858401",
    access: "Manager"
  },
  {
    id: "3",
    name: "Elonmask",
    email: "x@mail.com",
    age: 20,
    phone: "0101858401",
    access: "User"
  },
  {
    id: "4",
    name: "Elonmask",
    email: "x@mail.com",
    age: 20,
    phone: "0101858401",
    access: "Manager"
  },
  {
    id: "5",
    name: "Elonmask",
    email: "x@mail.com",
    age: 20,
    phone: "0101858401",
    access: "User"
  },
  {
    id: "6",
    name: "Elonmask",
    email: "x@mail.com",
    age: 20,
    phone: "0101858401",
    access: "Admin"
  },
  {
    id: "7",
    name: "Elonmask",
    email: "x@mail.com",
    age: 20,
    phone: "0101858401",
    access: "User"
  },
  {
    id: "8",
    name: "Elonmask",
    email: "x@mail.com",
    age: 20,
    phone: "0101858401",
    access: "User"
  },
  {
    id: "9",
    name: "Elonmask",
    email: "x@mail.com",
    age: 20,
    phone: "0101858401",
    access: "User"
  },
]